// extracted by mini-css-extract-plugin
export default {"toolFrame":"ToolFrame_toolFrame__j6N2n"};